import type React from 'react';

import classNames from 'classnames';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { LanguageIcon } from '../../icons/language';
import { Tooltip } from '../tooltip/tooltip';

import styles from './language-menu-button.module.css';

type Props = {
  isActive?: boolean;
  className?: string;
  onClick?: () => void;
};

export function LanguageMenuButton({ isActive, className, onClick }: Props) {
  const { t } = useTranslation();

  const label = isActive ? t('ui.language.menu.button.label.active') : t('ui.language.menu.button.label.inactive');
  const button = useCallback(
    (ref: React.LegacyRef<HTMLButtonElement>, props: Record<string, unknown>) => (
      <button
        data-testid="language-menu-button"
        type="button"
        name="language-menu-button"
        aria-expanded={isActive}
        aria-haspopup="true"
        className={classNames(styles.button, className)}
        onClick={onClick}
        ref={ref}
        {...props}
      >
        <LanguageIcon />
      </button>
    ),
    [className, isActive, onClick]
  );
  return <Tooltip tooltip={label} trigger={button} />;
}
